import Ajax from './Ajax';

function fetchTable(url, {tableName}, opts) {
    
    // we expect every parameter to be valid, so we do not need to validate parameters 
    return Ajax.promise_jsonp(url + "/json/do?v=2&table=" + tableName, {data: {}})
}


export default fetchTable;